export default {
  enabledWorkplaces: 'Aktivierte Arbeitsplätze',
  selectAll: 'Alle auswählen',
  deselectAll: 'Alle abwählen',
};
